/** Fußleisten-Filter (separat vom Such-Query). Status gehört zur Suche. */
export const UV_FOOTER_PARAM_KEYS = new Set([
  'period_start', 'period_end', 'active_only', 'active_on', 'gkz_group_id', 'gkz',
]);

export const UV_CONTROL_PARAM_KEYS = new Set([
  'page', 'per_page', 'mode', 'pageSize',
  '_keepEnrollmentId', '_quiet', '_keepPreviousOnEmpty', '_replaceQuery',
  'sort_by', 'sort_dir',
]);

/**
 * Teilt extraParams in Footer-Filter und Suchkriterien.
 * Sort-/Page-Reloads übergeben oft nur Footer — searchFromCall bleibt dann leer.
 */
export function partitionEnrollmentExtraParams(extraParams = {}) {
  const cleanFooter = {};
  const searchFromCall = {};
  Object.entries(extraParams || {}).forEach(([k, v]) => {
    if (UV_CONTROL_PARAM_KEYS.has(k)) return;
    if (v === undefined || v === null || v === '') return;
    if (UV_FOOTER_PARAM_KEYS.has(k)) cleanFooter[k] = v;
    else searchFromCall[k] = v;
  });
  return { cleanFooter, searchFromCall };
}

/**
 * Nächster listQueryRef-Inhalt.
 * - replaceQuery: komplette Ersetzung (Suche starten/löschen)
 * - searchFromCall nicht leer: Merge (status etc. bleiben erhalten)
 * - sonst: bisherige Query unverändert (Sortieren/Paginieren)
 */
export function nextEnrollmentListQuery(current, searchFromCall, replaceQuery = false) {
  if (replaceQuery) return { ...(searchFromCall || {}) };
  if (searchFromCall && Object.keys(searchFromCall).length > 0) {
    return { ...(current || {}), ...searchFromCall };
  }
  return { ...(current || {}) };
}
